import React, { useRef, useState, useEffect } from "react";
import styles from "./index.module.less";
import { Iconsvg, ButtonField, SelectField } from "@wk/components-react16";
import { useNavigate } from "react-router-dom";
import management from "@/assets/img/management.png";
import clinic from "@/assets/img/clinic.png";
import research from "@/assets/img/research.png";
import teaching from "@/assets/img/teaching.png";
// 这里需要导入背景图片，先使用占位符
import bannerBg from "@/assets/img/banner3.png"; // 待替换为真实的背景图路径
// 导入选决策标题图片
import titleImg from "@/assets/img/xjc.png"; // 需要添加实际的标题图片
import liangdian1 from "@/assets/img/index/liangdian_1.png";
import liangdian2 from "@/assets/img/index/liangdian_2.png";
import liangdian3 from "@/assets/img/index/liangdian_3.png";
import liangdian4 from "@/assets/img/index/liangdian_4.png";
import richeng1 from "@/assets/img/index/richeng_1.png";
import richeng2 from "@/assets/img/index/richeng_2.png";
import richeng3 from "@/assets/img/index/richeng_3.png";
import richeng4 from "@/assets/img/index/richeng_4.png";
import richeng5 from "@/assets/img/index/richeng_5.png";
import richeng6 from "@/assets/img/index/richeng_6.png";
import richeng7 from "@/assets/img/index/richeng_7.png";
import resource1 from "@/assets/img/resource1.png";
import resource2 from "@/assets/img/resource2.png";
import resource3 from "@/assets/img/resource3.png";
import resource4 from "@/assets/img/resource4.png";
import config from "@/config/env";

const Home = () => {
  const navigate = useNavigate();
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [activeMenu, setActiveMenu] = useState("highlights");
  const [activeFaqType, setActiveFaqType] = useState("basic");
  const [showContributionNotice, setShowContributionNotice] = useState(false);

  // 大赛分类部分的状态
  const [expandedCaseKey, setExpandedCaseKey] = useState("");

  const highlightsRef = useRef(null);
  const categoriesRef = useRef(null);
  const timelineRef = useRef(null);
  const faqRef = useRef(null);
  const pastCasesRef = useRef(null);

  const navMenuList = [
    { name: "本届亮点", section: "highlights", ref: highlightsRef },
    { name: "大赛分类及评分标准", section: "categories", ref: categoriesRef },
    { name: "大赛赛程", section: "timeline", ref: timelineRef },
    { name: "FAQ常见问题", section: "faq", ref: faqRef },
    { name: "更多资源", section: "pastCases", ref: pastCasesRef },
  ];

  const expandedCaseList = [
    {
      title: "临床案例",
      key: "clinic",
      headList: ["指标名称", "权重", "指标内容"],
      tableList: [
        {
          first: "案例完整度及科学性",
          second: "66",
          list: [
            "真实且全面的患者基本情况及相关病史",
            "完善的体格检查、实验室检查及影像学检查（含【图片】并有重点总结）",
            "完整且合理的诊断、鉴别诊断",
            "患者最终的诊断结果、选择的治疗方式、结局转归（随访预后等），需要结合UpToDate等相关循证资源展示治疗方法或选择药物的正确科学、规范性",
            "临床诊疗过程全面、清晰、严谨且逻辑性强，对案例有充分的思考回顾（以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述）",
            "查阅UpToDate等相关循证资源，充分了解该疾病当前最佳的诊疗策略及学术研究进展",
          ],
        },
        {
          first: "案例实际价值",
          second: "22",
          list: [
            "选择案例为疑难、罕见病、多学科疾病、易误诊疾病和复杂疾病",
            "经过循证检索之后，诊断和/或治疗疾病的方法有进一步的创新或优化，在专业领域有推广价值或对临床诊治有范例作用",
            "从临床实际问题中获得科研启发，或该案例有进一步研究的价值，并且有后续跟进",
          ],
        },
        {
          first: "案例规范及美观性",
          second: "12",
          list: [
            "PPT制作美观，有视觉效果",
            "图片清晰典型，表格及流程图规范精炼",
          ],
        },
        {
          first: "特殊加分",
          second: "20",
          list: [
            "有完整的应用临床循证数据库解决案例涉及问题(诊疗决策/辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: clinic,
    },
    {
      title: "住培案例",
      key: "residence",
      headList: ["指标名称", "权重", "评分内容"],
      tableList: [
        {
          first: "案例完整度及科学性",
          second: "66",
          list: [
            "真实且全面的患者基本情况及相关病史",
            "完善的体格检查、实验室检查及影像学检查（含【图片】并有重点总结）",
            "完整且合理的诊断、鉴别诊断",
            "患者最终的诊断结果、选择的治疗方式、结局转归（随访预后等），需要结合UpToDate等相关循证资源展示治疗方法或选择药物的正确科学、规范性",
            "临床诊疗过程全面、清晰、严谨且逻辑性强，对案例有充分的思考回顾（以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述）",
            "查阅UpToDate等相关循证资源，充分了解该疾病当前最佳的诊疗策略及学术研究进展",
          ],
        },
        {
          first: "案例实际价值",
          second: "22",
          list: [
            "选择案例为疑难、罕见病、多学科疾病、易误诊疾病和复杂疾病",
            "经过循证检索之后，诊断和/或治疗疾病的方法有进一步的创新或优化，在专业领域有推广价值或对临床诊治有范例作用",
            "从临床实际问题中获得科研启发，或该案例有进一步研究的价值，并且有后续跟进",
          ],
        },
        {
          first: "案例规范及美观性",
          second: "12",
          list: [
            "PPT制作美观，有视觉效果",
            "图片清晰典型，表格及流程图规范精炼",
          ],
        },
        {
          first: "特殊加分",
          second: "20",
          list: [
            "有完整的应用临床循证数据库解决案例涉及问题(诊疗决策/辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: clinic,
    },

    {
      title: "教学案例",
      key: "teaching",
      headList: ["评分项", "权重", "评分内容"],
      tableList: [
        {
          first: "案例内容",
          second: "60",
          list: [
            "与教学有关的患者情况（病史、检查结果、诊疗方式等），展示教学过程并总结，应有教学模式的亮点总结，教学结果的展示或预判",
            "案例选择有带教价值，教学模式有创新（包括基于如床边教学、以问题为导向的教学、以病例为基础的教学等场景模式下的真实教学案例，或其他创新教学模式）",
            "有完整的应用临床循证数据库解决案例涉及问题(辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "对案例有充分的思考回顾：以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述",
            "PPT制作是否美观，有视觉效果",
          ],
        },
        {
          first: "思维过程",
          second: "30",
          list: [
            "教学过程是否全面、清晰、严谨且逻辑性强",
            "基于循证医学对检索结果的决策过程：对证据的思考分析和最佳证据的筛选过程；",
            "有对该案例在证据分析和筛选上的应用总结及反思",
          ],
        },
        {
          first: "与UpToDate结合度",
          second: "10",
          list: [
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: teaching,
    },

    {
      title: "科研案例",
      key: "research",
      headList: ["指标名称", "权重", "评分内容"],
      tableList: [
        {
          first: "案例内容",
          second: "60",
          list: [
            "与科研有关的患者情况（病史、检查结果、诊疗方式或临床情况总结等）科研课题内容完整性，包括课题详情、在研情况、结果预判（立项阶段的阐述亦可）",
            "所选课题是否国内外未见报道；或在类似研究上有新颖点促使该课题有新的发展、补充或修正；国外已有研究，但尚需结合我国实际进行探素，填补国内此领域的空白，对临床的意义等",
            "有完整的应用临床循证数据库解决案例涉及问题(助力科研创新)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
            "对案例有充分的思考回顾：以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述",
            "PPT制作是否美观，有视觉效果",
          ],
        },
        {
          first: "思维过程",
          second: "30",
          list: [
            "科研过程是否全面、清晰、严谨且逻辑性强",
            "基于循证医学对检索结果的决策过程：对证据的思考分析和最佳证据的筛选过程",
            "有对该案例在证据分析和筛选上的应用总结及反思",
          ],
        },
        {
          first: "与UptoDate组合度",
          second: "10",
          list: [
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
          ],
        },
      ],
      img: research,
    },

    {
      title: "管理案例",
      key: "management",
      headList: ["评分项", "权重", "评分内容"],
      tableList: [
        {
          first: "案例完整度及合理性",
          second: "50",
          list: [
            "解决医务、教学、住培或科研方面的统筹管理相关问题",
            "清晰描述案例背景，待解决问题，及其影响和意义；",
            "呈现管理过程：分析-计划-执行-跟进-反馈-效果等相关环节",
          ],
        },
        {
          first: "案例实际价值",
          second: "20",
          list: [
            "选择案例可体现与医院现有流程的差异，显著改善管理效果",
            "案例具有普遍和借鉴意义，管理方法有创新性",
            "如何解决计划或执行中遇到的问题",
          ],
        },
        {
          first: "循证医学价值",
          second: "20",
          list: [
            "体现利用相关循证资源解决管理问题的优势",
            "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容给予了支持。",
          ],
        },
        {
          first: "案例规范及美观性",
          second: "10",
          list: ["符合大赛案例规范；", "图片清晰典型，表格及流程图规范精炼"],
        },
      ],
      img: management,
    },
  ];

  const timelineList = [
    {
      title: "赛事启动",
      list: ["4月30日大赛启动", "机构赛同步启动"],
      icon: richeng1,
    },
    {
      title: "全国投稿",
      list: ["6月1日启动投稿", "10月11日截止投稿"],
      icon: richeng2,
    },
    {
      title: "初赛评审",
      list: ["11月17日公布决赛名单"],
      icon: richeng3,
    },
    {
      title: "决赛赛前训练营",
      list: ["11月下旬决赛选手赛前训练营", "12月20日决赛截止投稿"],
      icon: richeng4,
    },
    {
      title: "决赛评审启动",
      list: ["12月21日决赛评审启动"],
      icon: richeng5,
    },
    {
      title: "稿件返修",
      list: ["2027年2月4日进行审阅<br/>返修稿件，并给出终审意见"],
      icon: richeng6,
    },
    {
      title: "公布决赛结果",
      list: ["2027年3月下旬公布获奖名单"],
      icon: richeng7,
    },
  ];

  const highlightList = [
    {
      title: "大赛奖项",
      content: ["卓越案例奖", "优秀案例奖", "优秀机构组织奖"],
      icon: liangdian1,
    },
    {
      title: "中国临床案例成果数据库直接收录",
      content: [
        "临床和住培案例“卓越案例奖”直接被中国临床案例成果数据库直接收录，中华医学会颁发收录证书",
      ],
      icon: liangdian2,
    },
    {
      title: "决赛环节",
      content: [
        "初赛PPT或PDF投稿",
        "决赛临床和住培案例按照中国临床案例成果数据库标准 采用Word投稿",
      ],
      icon: liangdian3,
    },
    {
      title: "决赛赛前训练营",
      content: [
        "威科医学联合中华医学会杂志社，为决赛临床与住培选手进行案例撰写培训",
      ],
      icon: liangdian4,
    },
  ];

  // FAQ data
  const faqData = {
    basic: [
      {
        category: "参赛资格",
        items: [
          {
            question: "是否对参赛者的专业、学历、医院等级等有要求？",
            answer:
              "无要求，面向全国各级医疗机构的临床医生、医学生及相关医疗从业人员。",
          },
          {
            question: "是否允许团队参赛？团队成员人数和构成是否有规定？",
            answer:
              "允许团队参赛，团队成员人数不做限制。但奖励机制按照参赛作品数量对应，不对应人数。",
          },
          {
            question: "往届获奖者是否可以再次参赛？",
            answer:
              "允许往届获奖者参赛，但需提交新的案例，不能重复使用已获奖案例。",
          },
        ],
      },
      {
        category: "案例要求",
        items: [
          {
            question:
              "案例类型是否有明确限制？例如，是否必须是疑难病例、罕见病例或具有教学意义的病例？",
            answer:
              "案例类型分为：临床、住培、教学、科研、管理。但疑难病例、罕见病例等具有创新性的病例更具有竞争优势。",
          },
          {
            question:
              "案例时间范围是否有要求？例如，是否必须是近期发生的病例？",
            answer:
              "要求案例为近1-2年内发生的病例，以确保案例的时效性和参考价值。",
          },
          {
            question: "是否可以使用已发表或已参加其他比赛的案例？",
            answer: "可以。",
          },
          {
            question: "案例中涉及的患者隐私信息如何处理？",
            answer: "案例必须隐去患者隐私信息（如姓名、身份证号等）。",
          },
        ],
      },
      {
        category: "比赛流程",
        items: [
          {
            question: "比赛分为几个阶段？每个阶段的具体时间和安排是怎样的？",
            answer:
              "比赛分为初赛和决赛。进入决赛后，主办方通过邮件或短信通知选手，并邀请参加决赛赛前训练营。具体时间参考官网中赛程安排。",
          },
          {
            question: "是否需要现场演讲？",
            answer:
              "不设置现场演讲。但获奖后，主办方将邀请获奖选手线上录制课程分享。",
          },
        ],
      },
      {
        category: "奖项设置",
        items: [
          {
            question: "比赛设有哪些奖项？每个奖项的获奖人数和奖励是什么？",
            answer:
              "比赛设置“优秀机构组织奖”、“卓越案例奖”、“优秀案例奖”，获奖总人数在30左右。奖励包含奖金、UpToDate使用权限。",
            table: {
              headList: ["奖项", "奖品"],
              tableList: [
                {
                  first: "优秀机构组织奖",
                  list: ["机构奖杯", "获奖证书"],
                },
                {
                  first: "卓越案例奖",
                  list: [
                    "UpToDate临床顾问全平台账号1年使用权",
                    "奖品（价值1000元）",
                    "获奖证书",
                  ],
                },
                {
                  first: "优秀案例奖",
                  list: [
                    "UpToDate临床顾问移动端账号1年使用权",
                    "奖品（价值800元）",
                    "获奖证书",
                  ],
                },
              ],
            },
          },
          {
            question: "问：获奖后UpToDate 账号使用权限如何分配？",
            answer: "每部获奖作品将获赠一个 UpToDate 账号，默认授予决赛时登记的作者。若团队获奖，经登记的第一作者同意，可转让给该作品登记的其他作者，但转让后不可变更且不可转予未参与案例创作的外部人员。",
          },
        ],
      },
    ],

    details: [
      {
        category: "投稿方式",
        items: [
          {
            question: "投稿是通过官方网站、邮箱还是其他平台？",
            answer: "目前仅支持官方网站投稿。",
          },
          {
            question: "投稿时需要提交哪些材料？例如，案例报告、PPT、视频等？",
            answer:
              "初赛投稿作品可接受PPT或PDF文件。如进入决赛，临床/住培案例需要按照中国临床案例成果数据库标准改写为完整的案例报告，采用Word或PDF文件投稿。",
          },
          {
            question: "投稿材料的格式和大小是否有要求？",
            answer: "PPT大小不超过100M。",
          },
        ],
      },
      {
        category: "案例报告撰写",
        items: [
          {
            question: "案例报告是否有固定模板？字数要求是多少？",
            answer: "案例无固定模板，不做字数要求",
          },
          {
            question:
              "案例报告需要包含哪些内容？例如，病史、检查、诊断、治疗、随访等？",
            answer:
              "病史、检查、诊断、治疗、随访及UpToDate的应用。详见评分标准。",
          },
          {
            question: "如何平衡案例报告的完整性和简洁性？",
            answer: "两者均占分值。详见评分标准。",
          },
        ],
      },
      {
        category: "其他问题",
        items: [
          {
            question: "投稿后是否可以修改或撤回？",
            answer: "投稿后，选手本人无法修改或撤回。",
          },
          {
            question: "如何查询投稿状态和评审结果？",
            answer: "关注赛事官网及UpToDate公众号。",
          },
          {
            question: "比赛组委会的联系方式是什么？",
            answer: "MKT_HealthChina@wolterskluwer.cn",
          },
        ],
      },
    ],

    help: [
      {
        category: "中国临床案例成果数据库收录相关问题",
        items: [
          {
            question: "何种案例能够被中国临床案例成果数据库收纳？",
            answer:
              "获得“卓越案例奖”的临床及住培案例将被中国临床案例成果数据库直接收录。",
          },
          {
            question: "如果投稿至中国临床案例成果数据库，是否允许多位作者？",
            answer: "投稿案例允许多个作者，但第一作者和通信作者均只能有一位。",
          },
          {
            question:
              "如果未能获得“卓越案例奖”，我是否依然可以尝试投稿中国临床案例成果数据库？",
            answer: "可以，请您按照中国临床案例成果数据库要求自行投稿。",
          },
          {
            question:
              "收录证书中的作者顺序是否可以调整？",
            answer: "作者排序应在投稿前由全体作者共同讨论确定，投稿后不应再作改动。稿件一经上线，作者顺序将不予更改。",
          },
          {
            question:
              "对审稿修改意见存在异议，应如何反馈？",
            answer: "若您对修改意见有不同看法，请直接拨打中国临床案例成果数据库编辑部电话咨询：010-51322290、010-51322297、010-51322298、010-51322300。",
          },
          {
            question:
              "投稿后一般多久能收到审稿意见？",
            answer: "中国临床案例成果数据库的专家审稿期限为1个月，实际以审稿专家的审稿进度为准。",
          }
        ],
      },
    ],
  };
  const weike = () => {
    // 在新窗口打开
    window.open("https://wolterskluwer.com/");
  };

  const utd = () => {
    // 在新窗口打开
    window.open("https://www.uptodate.cn/home");
  };

  // 立即试用
  const shiyong = () => {
    // 在新窗口打开
    window.open(
      "https://uptodatechina.secure.force.com/IndividualSubscribers?SourceCode=WeChatMenu"
    );
  };
  const resourcesList = [
    {
      title: "关于威科集团（Wolters Kluwer）",
      description:
        "威科集团（Wolters Kluwer）是全球知名的专业信息服务提供商之一。威科集团提供以信息为驱动力的先进工具和软件解决方案，法律、商业、税务、会计、财务、审计、风险、合规和医疗卫生等领域的专业人士依赖这些工具和软件高效管理各自的业务、向客户提供结果，助其在这个瞬息万变的世界中取得成功。",
      img: resource1,
      buttonText: "访问威科官网",
      onClick: weike,
    },
    {
      title: "关于UpToDate临床顾问",
      description:
        "UpToDate是威科医疗旗下以循证医学为基础的优质临床决策支持工具，服务于全球44,900多家医疗机构，为全球医生提供高效的医疗决策支持。UpToDate以即时、权威的内容，帮助医疗机构优化临床决策，提升医疗质量。",
      img: resource2,
      buttonText: "了解UpToDate",
      onClick: utd,
    },
    {
      title: "订阅UpToDate临床顾问",
      description:
        "UpToDate临床顾问为您提供多种试用及订购选项，您可根据实际情况进行选择。便捷的访问方式，让您随时随地都能浏览实用的循证临床诊疗信息。",
      img: resource3,
      buttonText: "立即订阅",
      onClick: shiyong,
    },
  ];

  const handleViewDetails = () => {
    // 点击投稿时先展示投稿开始时间提醒弹窗
    console.info("[Home] 打开投稿提醒弹窗");
    setShowContributionNotice(true);
  };

  const handleCloseContributionNotice = () => {
    // 关闭投稿提醒弹窗，便于后续排查用户交互路径
    console.info("[Home] 关闭投稿提醒弹窗");
    setShowContributionNotice(false);
  };

  const handleMenuToggle = () => {
    setMenuExpanded(!menuExpanded);
  };

  const handleMenuSelect = (section) => {
    // setActiveMenu(section);
    setMenuExpanded(false);

    // 滚动到对应部分
    const ref = navMenuList.find((item) => item.section === section)?.ref;
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    // 使用节流函数优化滚动处理
    const throttle = (func, delay) => {
      let lastCall = 0;
      return (...args) => {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return func(...args);
      };
    };

    const handleScroll = () => {
      // 检测当前哪个部分在视口中最突出
      const scrollPosition = window.scrollY + 250; // 添加偏移量，使导航项更早激活

      // 遍历所有部分，查找当前滚动位置中最突出的部分
      let currentSection = "highlights";

      // 从后往前检查，这样可以正确处理重叠的部分
      for (let i = navMenuList.length - 1; i >= 0; i--) {
        const { section, ref } = navMenuList[i];
        if (ref.current && ref.current.offsetTop <= scrollPosition) {
          currentSection = section;
          break;
        }
      }

      // 如果找到了不同的部分，更新activeNav状态
      if (currentSection !== activeMenu) {
        setActiveMenu(currentSection);
      }
    };

    // 使用节流函数包装滚动处理函数，限制为每100ms最多执行一次
    const throttledHandleScroll = throttle(handleScroll, 100);

    // 添加滚动事件监听器
    window.addEventListener("scroll", throttledHandleScroll);

    // 初始化检查当前部分
    handleScroll();

    // 清理函数：移除滚动事件监听器
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
    };
  }, [activeMenu, navMenuList]); // 依赖项

  return (
    <div className={styles["home-container"]}>
      {/* Banner区域 */}
      <div className={styles["banner-section"]}>
        <div className={styles["banner-background"]}>
          {/* 背景图片 */}
          <img
            src={bannerBg}
            alt="背景"
            className={styles["background-image"]}
          />
        </div>
        <div className={styles["banner-content"]}>
          <img
            src={titleImg}
            alt="选决策"
            className={styles["banner-title-img"]}
          />
          <p className={styles["banner-subtitle"]}>
            第九届UpToDate临床顾问案例大赛
          </p>
          <p
            className={styles["banner-description"]}
            style={{ visibility: "hidden" }}
            onClick={() => {
              window.open(
                "https://mp.weixin.qq.com/s/A41xQQcol5NYVFLNYEVirA",
                "_blank"
              );
            }}
          >
            决赛入围名单已正式出炉！
          </p>
          <p
            className={styles["banner-date"]}
            style={{ visibility: "hidden" }}
            onClick={() => {
              window.open(
                "https://mp.weixin.qq.com/s/A41xQQcol5NYVFLNYEVirA",
                "_blank"
              );
            }}
          >
            点我查看链接
          </p>
          <ButtonField iconPosition={"right"}>
            <button type="button" onClick={() => handleViewDetails()}>
              点击投稿
              <Iconsvg name="arrow-right"></Iconsvg>
            </button>
          </ButtonField>
        </div>
      </div>

      {/* 黑色菜单栏 */}
      <div className={styles["menu-bar"]}>
        <div className={styles["active-menu"]}>
          {navMenuList.find((item) => item.section === activeMenu)?.name ||
            "本届亮点"}
        </div>
        <div className={styles["menu-dropdown"]} onClick={handleMenuToggle}>
          {/* <div className={styles["menu-text"]}>目录</div> */}

          <div className={styles["menu-text"]}>目录</div>
          <Iconsvg
            name={menuExpanded ? "chevron-up" : "chevron-down"}
            size={14}
            className={styles["menu-icon"]}
          />
        </div>

        {menuExpanded && (
          <div className={styles["menu-list"]}>
            {navMenuList.map((item) => (
              <div
                key={item.section}
                className={`${styles["menu-item"]} ${
                  activeMenu === item.section ? styles["menu-item-active"] : ""
                }`}
                onClick={() => handleMenuSelect(item.section)}
              >
                {item.name}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 本届亮点部分 */}
      <div className={styles["highlights-section"]} ref={highlightsRef}>
        <div className={styles["highlights-header"]}>
          <h2 className={styles["highlights-title"]}>本届亮点</h2>
        </div>

        <div className={styles["highlights-intro"]}>
          <p>
            2018年起“UpToDate临床顾问案例大赛”正式启动，旨在促进循证医学在临床工作中的实践与应用，助力提升诊疗质量、赋能医学教育、优化科研选题。 
          </p>
          <p>
            截至2025年底已收获50余个专科、超过2800份投稿案例，覆盖150家机构，80多场机构赛，大赛权威评审专家共计70余名，10,000+临床参赛者。UpToDate临床顾问案例大赛设置五大分组：<span style={{ "font-weight": "bold" }}>临床案例、住培案例、管理案例、教学案例、科研案例</span>。
          </p>
        </div>

        {/* 四个特色模块 */}
        <div className={styles["features-container"]}>
          {highlightList.map((item) => (
            <div className={styles["feature-card"]} key={item.title}>
              <div className={styles["feature-icon-container"]}>
                <img
                  src={item.icon}
                  alt={item.title}
                  className={styles["highlight-icon"]}
                />
              </div>
              <div className={styles["feature-content"]}>
                <h3 className={styles["feature-title"]}>{item.title}</h3>
                {/* 使用无序列表绑定亮点文案 */}
                <ul className={styles["feature-desc-list"]}>
                  {item.content.map((text) => (
                    <li key={text} className={styles["feature-desc-item"]}>
                      {text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 大赛分类及评分标准部分 */}
      <div className={styles["categories-section"]} ref={categoriesRef}>
        <div className={styles["section-title"]}>大赛分类及评分标准</div>

        {/* 案例类型折叠菜单 */}
        <div className={styles["case-categories"]}>
          {expandedCaseList.map((caseItem) => (
            <div
              key={caseItem.key}
              className={`${styles["case-category-item"]} ${
                expandedCaseKey === caseItem.key
                  ? styles["case-category-expanded"]
                  : ""
              }`}
            >
              <div
                className={`${styles["case-category-header"]} ${caseItem.key}`}
                onClick={() => {
                  setExpandedCaseKey(
                    expandedCaseKey === caseItem.key ? "" : caseItem.key
                  );
                  setTimeout(() => {
                    if (expandedCaseKey !== caseItem.key) {
                      const caseCategoryRef = document.querySelector(
                        `.${caseItem.key}`
                      );
                      if (caseCategoryRef) {
                        // 滚动到对应的案例类型部分
                        window.scrollTo({
                          top: caseCategoryRef.offsetTop - 50,
                          behavior: "smooth",
                        });
                      }
                    }
                  }, 0);
                }}
              >
                <span className={styles["case-category-title"]}>
                  {caseItem.title}
                </span>
                <Iconsvg
                  name={
                    expandedCaseKey === caseItem.key
                      ? "chevron-up"
                      : "chevron-down"
                  }
                  size={16}
                  color={expandedCaseKey === caseItem.key ? "#fff" : "#007ac3"}
                />
              </div>
              {expandedCaseKey === caseItem.key && (
                <div className={styles["case-category-content"]}>
                  <div className={styles["content-container"]}>
                    {/* 雷达图部分 - 所有案例都显示 */}
                    <div className={styles["radar-chart-container"]}>
                      <div className={styles["radar-chart"]}>
                        {caseItem.img && (
                          <img
                            src={caseItem.img}
                            alt={`${caseItem.title}雷达图`}
                            className={styles["case-img"]}
                          />
                        )}
                      </div>
                    </div>

                    {/* 评分标准详情 */}
                    <div className={styles["scoring-criteria"]}>
                      {/* 评分项目列表 */}
                      {caseItem.tableList &&
                        caseItem.tableList.map((item, index) => (
                          <div key={index} className={styles["criteria-item"]}>
                            <div className={styles["criteria-header"]}>
                              <span className={styles["criteria-title"]}>
                                {item.first}
                              </span>
                              <span className={styles["criteria-score"]}>
                                {item.second}
                              </span>
                            </div>
                            <ul className={styles["criteria-details"]}>
                              {item.list.map((detail, detailIndex) => (
                                <li key={detailIndex}>{detail}</li>
                              ))}
                            </ul>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* 大赛赛程部分 */}
      <div className={styles["timeline-section"]} ref={timelineRef}>
        <div className={styles["section-title"]}>大赛赛程</div>

        <div className={styles["timeline-container"]}>
          {timelineList.map((item, index) => (
            <div key={index} className={styles["timeline-item"]}>
              <div className={styles["timeline-icon-container"]}>
                <div className={styles["timeline-icon"]}>
                  {/* 赛程节点图标改为图片资源，按时间节点一一绑定 */}
                  <img
                    src={item.icon}
                    alt={item.title}
                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  />
                </div>
                {index < timelineList.length - 1 && (
                  <div className={styles["timeline-line"]}></div>
                )}
              </div>
              <div className={styles["timeline-content"]}>
                <div className={styles["timeline-title"]}>{item.title}</div>
                {/* 使用无序列表展示赛程详情 */}
                <ul className={styles["timeline-details"]}>
                  {item.list.map((text, i) => (
                    <li key={i} className={styles["timeline-text"]}>
                      {text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ常见问题部分 */}
      <div className={styles["faq-section"]} ref={faqRef}>
        <div className={styles["section-title"]}>FAQ常见问题</div>

        <div className={styles["faq-container"]}>
          {/* FAQ分类选择框 */}
          <div className={styles["faq-category-select"]}>
            <SelectField
              className={`${styles["faq-select-wrapper"]} faq-custom-select`}
              iconColor="#007ac3"
            >
              <select
                className={styles["faq-select"]}
                onChange={(e) => setActiveFaqType(e.target.value)}
                value={activeFaqType}
              >
                <option value="basic">赛程赛制</option>
                <option value="details">投稿</option>
                <option value="help">中国临床案例成果数据库收录相关问题</option>
              </select>
            </SelectField>
          </div>

          {/* FAQ问题列表 */}
          <div className={styles["faq-list"]}>
            {faqData[activeFaqType]?.map((section, sectionIndex) => (
              <div key={sectionIndex} className={styles["faq-section-group"]}>
                <div className={styles["faq-category"]}>{section.category}</div>
                {section.items.map((item, itemIndex) => (
                  <div key={itemIndex} className={styles["faq-item"]}>
                    <div className={styles["faq-question"]}>
                      <span className={styles["question-prefix"]}>问：</span>
                      <span className={styles["question-text"]}>
                        {item.question}
                      </span>
                    </div>
                    <div className={styles["faq-answer"]}>
                      <span className={styles["answer-prefix"]}>答：</span>
                      <span className={styles["answer-text"]}>
                        {item.answer}
                      </span>
                    </div>

                    {item["table"] && (
                      <div className={styles["scoring-criteria"]}>
                        {/* 评分项目列表 */}
                        {item["table"].tableList &&
                          item["table"].tableList.map((item, index) => (
                            <div
                              key={index}
                              className={styles["criteria-item"]}
                            >
                              <div className={styles["criteria-header"]}>
                                <span className={styles["criteria-title"]}>
                                  {item.first}
                                </span>
                                {/* <span className={styles["criteria-score"]}>
                                  {item.second}
                                </span> */}
                              </div>
                              <ul className={styles["criteria-details"]}>
                                {item.list.map((detail, detailIndex) => (
                                  <li key={detailIndex}>{detail}</li>
                                ))}
                              </ul>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 更多资源部分 */}
      <div className={styles["resources-section"]} ref={pastCasesRef}>
        <div className={styles["resources-title"]}>更多资源</div>

        <div className={styles["resources-container"]}>
          {resourcesList.map((resource, index) => (
            <div key={index} className={styles["resource-card"]}>
              {resource.img && (
                <div className={styles["resource-image-container"]}>
                  <img
                    src={resource.img}
                    alt={resource.title}
                    className={styles["resource-image"]}
                  />
                </div>
              )}
              <div className={styles["resource-content"]}>
                <div className={styles["resource-title"]}>{resource.title}</div>
                <div className={styles["resource-description"]}>
                  {resource.description}
                </div>

                <ButtonField iconPosition={"right"} mode={"ghost"}>
                  <button type="button" onClick={() => resource.onClick()}>
                    {resource.buttonText}
                    <Iconsvg name="arrow-right"></Iconsvg>
                  </button>
                </ButtonField>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showContributionNotice && (
        <div
          className={styles["notice-modal-mask"]}
          onClick={handleCloseContributionNotice}
        >
          <div
            className={styles["notice-modal-card"]}
            onClick={(event) => event.stopPropagation()}
          >
            <div className={styles["notice-modal-title"]}>温馨提示</div>
            <div className={styles["notice-modal-content"]}>
              请用电脑端访问uptodatecontest.wolterskluwer.cn进行投稿。
            </div>
            <button
              type="button"
              className={styles["notice-modal-confirm"]}
              onClick={handleCloseContributionNotice}
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
